import { render, staticRenderFns } from "./emailInvoiceModal.vue?vue&type=template&id=f6f4b5d6&scoped=true&"
import script from "./emailInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./emailInvoiceModal.vue?vue&type=script&lang=js&"
import style0 from "./emailInvoiceModal.vue?vue&type=style&index=0&id=f6f4b5d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f4b5d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardTitle,VCol,VDialog,VFooter,VRow})
